module.exports = __webpack_public_path__ + "img/bg2.faba3225.png";